import React from 'react'
import { withI18n, withI18nProps } from '@lingui/react'
import HeadTitle from 'client/shared/blocks/head-title'
import Meta from 'client/shared/blocks/meta'

type Props = withI18nProps & {
  children: React.ReactNode
}

class SubscriptionPage extends React.Component<Props> {
  render() {
    return (
      <div>
        {this.renderMeta()}
        {this.props.children}
      </div>
    )
  }

  renderMeta() {
    const { i18n } = this.props
    const headTitle = i18n.t`subscription.head_title`
    const metaDescription = i18n.t`subscription.meta_description`

    return (
      <div>
        <HeadTitle>{headTitle}</HeadTitle>
        <Meta name="description" content={metaDescription} />
      </div>
    )
  }
}

export default withI18n({ update: true })(SubscriptionPage)
